import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PageBulkGrantIndexResponse } from '@/repositories/generated';

const response: PageBulkGrantIndexResponse = {
  content: [
    {
      id: '1',
      name: 'testPublic',
      systemName: 'testBulkGrant',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-03T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-02T00:00:00+09:00',
      bulkGrantStatus: 'SCHEDULED',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '2',
      name: 'testPublic2',
      systemName: 'testBulkGrant2',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'UPLOAD_PROGRESS',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '3',
      name: 'testPublic3',
      systemName: 'testBulkGrant3',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'UPLOAD_FAILURE',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '4',
      name: 'testPublic4',
      systemName: 'testBulkGrant4',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'SCHEDULED_CANCELED',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '5',
      name: 'testPublic5',
      systemName: 'testBulkGrant5',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'PROGRESS',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '6',
      name: 'testPublic6',
      systemName: 'testBulkGrant6',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'DONE',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
    {
      id: '7',
      name: 'testPublic7',
      systemName: 'testBulkGrant7',
      walletService: {
        id: '001',
        name: 'テストWS1',
      },
      grantScheduleDateTime: '2023-01-23T00:00:00+09:00',
      grantSchedulePublishDateTime: '2023-01-22T00:00:00+09:00',
      bulkGrantStatus: 'FAILURE',
      detailCount: 15,
      scheduleCount: 1,
      grantCount: 3,
      failureCount: 4,
      grantCancelCount: 5,
      scheduleCancelCount: 2,
      createdBy: '山田 太郎',
      createdAt: '2023-01-01T00:00:00+09:00',
      remarks: '',
    },
  ],
  pageable: {
    sort: {
      empty: true,
      sorted: false,
      unsorted: true,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 20,
    paged: true,
    unpaged: false,
  },
  totalElements: 7,
  totalPages: 1,
  last: true,
  size: 20,
  number: 0,
  sort: {
    empty: true,
    sorted: false,
    unsorted: true,
  },
  numberOfElements: 7,
  first: true,
  empty: false,
};

export const bulkGrant = http.get(
  createMockEndpoint('/bulk_grant'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
